import $ from 'jquery';
import { checkFaders, inScreen } from './animations.js';

export default (limit) => ({
  posts: [],
  loading: false,
  offset: limit,
  limit: limit,

  init() {
    let _this = this;

    function checkItems() {
      let lastItem = _this.$el.querySelector('.post-card:last-of-type');

      if (!_this.loading && inScreen(lastItem, 1.5)) {
        _this.loadPosts();
      }
    }

    window.addEventListener('scroll', checkItems);
    window.addEventListener('resize', checkItems);
    checkItems();
  },
  loadPosts() {
    this.loading = true;

    $.get('/wp-json/wp/v2/gallery', {
      _fields: 'title,src,srcset,alt,link',
      offset: this.offset,
      per_page: this.limit
    }, (response) => {
      if (response.length != 0) {
        this.offset += response.length;
        this.posts = this.posts.concat(response);
        this.loading = false;
        setTimeout(checkFaders, 200);
      }
    });
  }
});